import classNames from "classnames";
import styles from "./Avatar.module.scss";
import Tooltip from "../Tooltip/Tooltip";
import * as AvatarPrimitive from "@radix-ui/react-avatar";

interface AvatarProps {
  size?: "xsmall" | "small" | "medium";
  className?: string;
  imageUrl?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  showNameAndEmail?: boolean;
  showName?:
    | boolean
    | {
        firstName?: boolean;
        lastName?: boolean;
      };
  showEmail?: boolean;
  hideTooltip?: boolean;
}

function Avatar({
  size = "medium",
  imageUrl,
  className,
  firstName,
  lastName,
  email,
  showNameAndEmail,
  showName,
  showEmail,
  hideTooltip,
}: AvatarProps) {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  const fallback = (fullName || email)?.charAt(0).toUpperCase();

  let displayName = fullName;

  if (showName && typeof showName == "object") {
    if (showName.firstName && !showName.lastName && firstName) {
      displayName = firstName;
    }

    if (showName.lastName && !showName.firstName && lastName) {
      displayName = lastName;
    }
  }

  return (
    <Tooltip
      content={fullName}
      open={hideTooltip || !fullName ? false : undefined}
    >
      <div className={classNames(styles.container, styles[size])}>
        <AvatarPrimitive.Root className={classNames(styles.avatar, className)}>
          {imageUrl && (
            <AvatarPrimitive.Image
              alt="Profile Image"
              className={styles.image}
              src={imageUrl}
            />
          )}
          <AvatarPrimitive.Fallback delayMs={0}>
            {fallback}
          </AvatarPrimitive.Fallback>
        </AvatarPrimitive.Root>

        {(showName || showEmail) && (
          <div className={styles.textContainer}>
            {showName && (
              <div className={styles.name}>{displayName ?? `-`}</div>
            )}
            {showEmail && <div className={styles.email}>{email ?? "-"}</div>}
          </div>
        )}

        {showNameAndEmail && (
          <div className={styles.textContainer}>
            <div className={styles.name}>{fullName ?? "-"}</div>
            <div className={styles.email}>{email ?? "-"}</div>
          </div>
        )}
      </div>
    </Tooltip>
  );
}

export default Avatar;
